import { useEffect } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

import { WordRushSplash } from '../components/wr';

/**
 * Splash — full-screen branded logo (W/R/U/! tile mark + animated
 * "wordrush by nookli" wordmark) for ~1.6s, then auto-routes by auth state.
 */
export default function SplashScreen() {
  const navigate = useNavigate();
  const { currentUser, userProfile, loading } = useAuth();

  useEffect(() => {
    if (loading) return;
    const t = setTimeout(() => {
      // If signed in, go straight to /home — never /setup. Forcing /setup
      // here was the cause of the "every login asks me to choose my
      // profile" loop: when Firestore was a few hundred ms slow to return
      // userProfile, the user got kicked to setup even though they'd
      // already saved one. Home decides whether to surface the setup
      // prompt based on whether the profile actually loaded.
      if (currentUser) navigate('/home', { replace: true });
      else navigate('/login', { replace: true });
    }, 1800);
    return () => clearTimeout(t);
  }, [loading, currentUser, userProfile, navigate]);

  return (
    <div
      className="app-shell wr-center"
      style={{
        minHeight: '100vh',
        background:
          'radial-gradient(circle at 50% 30%, rgba(255,90,31,0.18), transparent 60%), var(--bg)',
      }}
    >
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.3 }}>
        <WordRushSplash size="lg" />
      </motion.div>
    </div>
  );
}
